var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9856 5.03596C13.3485 5.21741 13.3485 5.51159 12.9856 5.69304C12.6227 5.87449 12.0343 5.87448 11.6715 5.69304C11.3086 5.5116 11.3085 5.21741 11.6715 5.03596C12.0344 4.85452 12.6227 4.85452 12.9856 5.03596Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9091 7.63636L10.3636 10.9091L18.5455 7.09091H13.6364V7.63636H10.9091Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18182 0C1.07723 0 0 0.895432 0 2V21.8182C0 22.9227 1.07723 24 2.18182 24H21.8182C22.9228 24 24 22.9227 24 21.8182V2.18182C24 1.07725 22.9228 0 21.8182 0H2.18182ZM2.18182 7.63636L12 3.27273L21.8182 7.63636L12 12.5455L2.18182 7.63636ZM6.54545 10.9091L4.36364 12L12 15.2727L19.6364 12L17.4545 10.9091L18.5455 10.3636L21.8182 12L12 16.3636L2.18182 12L5.45455 10.3636L6.54545 10.9091ZM4.36364 16.3636L6.54545 15.2727L5.45455 14.7273L2.18182 16.3636L12 20.7273L21.8182 16.3636L18.5455 14.7273L17.4545 15.2727L19.6364 16.3636L12 19.6364L4.36364 16.3636Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/Focus.3d2ab798089bc55a66c5c1168c5304ec.svg";
export { ForwardRef as ReactComponent };